// extracted by mini-css-extract-plugin
export default {"body":"TrashWindow_body__NOPDc","grid":"TrashWindow_grid__hy6fm","file":"TrashWindow_file__ekes+","fileIcon":"TrashWindow_fileIcon__GiViD","fileLabel":"TrashWindow_fileLabel__etSm2"};